import recursiveFunctionStepParser from '../recursiveFunctionStepParser';
import functionResponseObjectExtractor from '../general/functionResponseObjectExtractor';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={},
    setStateFunction
){
    try{
        let updatedVariables = variableObject;
        const {
            executionObject={}
        } = functionObj;
        const {
            iterationId='',
            functionObject={},
        } = executionObject;

        const {
            functionSteps=[]
        } = functionObject;
        let normalizedFunctionSteps = [], responseObject={};
        for (let k = 0; k < functionSteps.length; k++){
            let workflow = functionSteps[k];
            let steps = workflow['functionSteps'] || [];
            normalizedFunctionSteps.push(...steps);
        }

        if(navigator.geolocation){
            await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    async position => {
                        parameterObject[`userPosition_${iterationId}`] = position;
                        let functionResponse = await recursiveFunctionStepParser(
                            normalizedFunctionSteps,
                            updatedVariables,
                            parameterObject,
                            functionMap,
                            variableIdMap,
                            setStateFunction
                        );
                        responseObject = functionResponseObjectExtractor(functionResponse);
                        resolve();
                    },
                    error => {
                        console.log('getCurrentPosition error', error);
                        resolve(); // resolve (not reject) so execution continues
                    }
                );
            });
        }

        return responseObject;
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/getCurrentPositionParser catch block error', e)
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}